import React from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { PageBanner } from "../../components/PageBanner/PageBanner";
import { FAQs } from "./FaqQuestions";
import { FaqSection } from "./FaqSection";

export interface IFaqViewProps{}

export const FaqView: React.FunctionComponent<IFaqViewProps> = () => {
    return (
        <>
            <PageBanner title="FAQ" isPublic/>
            <CenteredContainer>
                {FAQs.map(section => {
                    return <FaqSection key={section.name} section={section} />;
                })}
            </CenteredContainer>
        </>
    );
};
